
import React, { useRef, useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { ApiUrl } from "../../../ApiUrl";
import { fetchLoggedInTeacherOption } from "../../hooks/fetchLoggedInTeacherOption";

const AdmAttendanceEntry = () => {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [mentors, setMentors] = useState([]);
  const [students, setStudents] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [selectedMentor, setSelectedMentor] = useState(null);
  const [studentLoadError, setStudentLoadError] = useState("");

  const dateRef = useRef(null);
  const fromClassRef = useRef(null);
  const toClassRef = useRef(null);
  const admissionNoRef = useRef(null);
  const barcodeRef = useRef(null);
  const smsToRef = useRef(null);

  const handleClear = () => {
    // Clear input fields
    if (dateRef.current) dateRef.current.value = "";
    if (fromClassRef.current) fromClassRef.current.value = "";
    if (toClassRef.current) toClassRef.current.value = "";
    if (admissionNoRef.current) admissionNoRef.current.value = "";
    if (barcodeRef.current) barcodeRef.current.value = "";
    if (smsToRef.current) smsToRef.current.checked = false;

    // Clear state variables
    setSelectedStudent(null);
    setData([]); // Clear other data if needed
    setStudentLoadError("");
  };
  

  useEffect(() => {
    const loadLoggedInMentor = async () => {
      try {
        const loggedInMentor = await fetchLoggedInTeacherOption();

        if (loggedInMentor) {
          setMentors([loggedInMentor]);
          setSelectedMentor(loggedInMentor);
        } else {
          setMentors([]);
          setSelectedMentor(null);
        }
      } catch (error) {
        console.error("Error fetching mentors:", error);
        setMentors([]);
        setSelectedMentor(null);
      }
    };

    loadLoggedInMentor();
  }, []);

  const branchId = localStorage.getItem("branchId");
  const orgId = localStorage.getItem("orgId");
  const academicYearId = localStorage.getItem("academicSessionId");

  useEffect(() => {
    if (!selectedMentor) return;

    const fetchStudents = async () => {
      try {
        setStudentLoadError("");
        const url = `${ApiUrl.apiurl}Mentor/mentorWiseStudentList/?academic_year_id=${academicYearId}&org_id=${orgId}&branch_id=${branchId}&teacher_id=${selectedMentor.value}`;
        const response = await fetch(url);
        const contentType = response.headers.get("content-type") || "";

        if (!response.ok) {
          const rawError = await response.text();
          throw new Error(
            rawError && rawError.trim().startsWith("<")
              ? "Mentor-wise student list API failed on the server."
              : rawError || "Unable to fetch students."
          );
        }

        if (!contentType.includes("application/json")) {
          throw new Error("Student API returned an unexpected response.");
        }

        const data = await response.json();

        if (data && data.data) {
          const formattedStudents = data.data.map((student) => ({
            value: student.student_id, // Corrected key mapping
            label: student.student_name, // Corrected key mapping
          }));
          setStudents(formattedStudents);
        } else {
          setStudents([]);
        }
      } catch (error) {
        console.error("Error fetching students:", error);
        setStudents([]);
        setSelectedStudent(null);
        setData([]);
        setStudentLoadError(error.message || "Unable to fetch students.");
      }
    };

    fetchStudents();
  }, [selectedMentor, academicYearId, orgId, branchId]);

  const handleSearch = async () => {
    const branchId = localStorage.getItem("branchId");
    const orgId = localStorage.getItem("orgId");
    const academicYearId = localStorage.getItem("academicSessionId");

    if (!branchId || !orgId || !academicYearId) {
      console.error(
        "Mandatory fields are missing: branchId, orgId, academicYearId"
      );
      return;
    }

    const studentId = selectedStudent ? selectedStudent.value : "";
    const teacherId = selectedMentor ? selectedMentor.value : "";

    const apiUrl = `${ApiUrl.apiurl}Mentor_Student_Communication/studentcommunicationSearchList/?academic_year_id=${academicYearId}&org_id=${orgId}&branch_id=${branchId}&student_id=${studentId}&teacher_id=${teacherId}`;

    try {
      const response = await fetch(apiUrl);
      const result = await response.json();

      if (result.message === "success") {
        setData(result.data);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleAssignMentorClick = () => {
    navigate("/staff/student-mentor-communication");
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                STUDENT MENTOR
              </p>
              <div className="row mb-3 mt-3 mx-0">
                <div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleAssignMentorClick} // Navigate to the mentor assignment page
                  >
                    New
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleSearch}
                  >
                    Search
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    onClick={handleClear}
                    style={{
                      width: "150px",
                    }}
                  >
                    Clear
                  </button>

                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={() => navigate("/staff/dashboard")}
                  >
                    Close
                  </button>
                </div>
              </div>

              <div className="row mt-3 mx-2">
                <div className="col-12 custom-section-box">
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    <div className="row flex-grow-1 mt-2">
                      <div className="col-12 col-md-4 mb-4">
                        <label
                          htmlFor="mentor"
                          className="form-label me-2"
                          style={{ whiteSpace: "nowrap", minWidth: "80px" }}
                        >
                          Mentor
                        </label>
                        <Select
                          id="mentor"
                          options={mentors}
                          value={selectedMentor}
                          isDisabled
                          placeholder="Logged-in mentor"
                          classNamePrefix="mentor-dropdown"
                          className="detail"
                        />
                      </div>
                      <div className="col-12 col-md-4 mb-4">
                        <label
                          htmlFor="student-name"
                          className="form-label me-2"
                          style={{ whiteSpace: "nowrap", minWidth: "110px" }}
                        >
                          Student Name
                        </label>
                        <Select
                          id="student-name"
                          classNamePrefix="student-name-dropdown"
                          className="detail"
                          options={students} // Dropdown values appear only after selecting a mentor
                          placeholder="Select Student"
                          isDisabled={!selectedMentor} // Disables dropdown until a mentor is selected
                          value={selectedStudent}
                          onChange={setSelectedStudent}
                        />
                        {studentLoadError ? (
                          <small className="text-danger d-block mt-2">
                            {studentLoadError}
                          </small>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Sr.No</th>
                        <th>Date</th>
                        <th>Student Name</th>
                        <th>class</th>
                        <th>Section</th>
                        <th>Mentor</th>
                        <th>Communicated With</th>
                        <th>Communicated Via</th>
                        <th>Communication Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.length > 0 ? (
                        data.map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.date}</td>
                            <td>{item.studentname}</td>
                            <td>{item.classname}</td>
                            <td>{item.sectionname}</td>
                            <td>{item.mentorname}</td>
                            <td>{item.communicated_with}</td>
                            <td>{item.communicated_via}</td>
                            <td>{item.remarks}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center">
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmAttendanceEntry;
